// 全局对象key
const DATABRAIN_WINDOW_STATE_KEY = '_dtb_win_state';
export const IS_SEARCH_HOME = 'isSearchHome'; // 进入search页面时，时候是在home状态下
// 定义一个全局状态对象，用于存储应用的状态数据
// 使用 Record<string, unknown> 类型表示这是一个键为字符串，值为任意类型的对象
const state: Record<string, unknown> = {};
/**
 * 获取指定locale对应的状态值
 * @param locale - 状态键名，通常用于标识不同的语言环境或其他分类
 * @returns 返回与locale关联的状态值，如果不存在则返回undefined
 */
export const getLocaleState = <T = unknown>(locale: string): T | undefined => state[locale] as T | undefined;
/**
 * 设置指定locale的状态值
 * @param locale - 状态键名，用于标识要设置的状态项
 * @param value - 要设置的值，可以是任意类型
 */
export const setLocaleState = <T>(locale: string, value: T) => {
  // value
  state[locale] = value;
};

const win = window as any;

// 挂载在window下的全局变量

/**
 * 获取挂载在window下的全局变量
 * @param key
 * @returns any
 */
export const getWindowState = (key: string): any => win?.[DATABRAIN_WINDOW_STATE_KEY]?.[key];

/**
 * 设置全局变量，挂载在window对象下
 * @param key: string
 * @param value: any
 * @returns void
 */
export const setWindowState = (key: string, value: any): void => {
  if (!win[DATABRAIN_WINDOW_STATE_KEY]) {
    win[DATABRAIN_WINDOW_STATE_KEY] = {};
  }
  win[DATABRAIN_WINDOW_STATE_KEY][key] = value;
};

/**
 * 获取首页搜索entity_type参数
 */
export const getEntityTypeParms = (entityType: string) => {
  switch (entityType) {
    case 'pcconsole':
      return 'pc,console';
    case 'all':
      return 'mobile,pc,console';
    default:
      return entityType;
  }
};